export const customStyles = {
    control: (base) => ({
        ...base,
        backgroundColor: "white",
    }),
    placeholder: (base) => ({
        ...base,
        color: "#585858",
    }),
    noOptionsMessage: (base) => ({
        ...base,
        color: "#585858",
    }),
};
